import { loginConst } from '../constants/actionConstants';
import { objPendingErrorFalse } from '../constants/variableConstant';
import produce from 'immer';
const initState = {
  loginInfo: { obj: {} },
  menus: { obj: [] },
  pending: false,
  error: false,
};

export default (state = initState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case loginConst.GET_MENUS:
        draft.pending = true;
        break;
      case loginConst.GET_MENUS_SUCCESS:
        draft.menus = action.payload;
        draft.pending = false;
        break;
      case loginConst.LOGIN_RESET_STATE:
        return initState;
      default:
        return state;
    }
  });
